import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import {
  type AccessPolicyUpdate,
  type AdminGroupsResponse,
  getAdminGroups,
  updateAdminGroupPolicy,
} from "@/api/admin-api"

import { GC_TIME, SLOW_STALE_TIME } from "./_shared"

export function useAdminGroupsQuery(enabled = true) {
  return useQuery<AdminGroupsResponse>({
    queryKey: ["admin", "admin-groups"],
    queryFn: getAdminGroups,
    enabled,
    staleTime: SLOW_STALE_TIME,
    gcTime: GC_TIME,
    refetchOnWindowFocus: false,
  })
}

export function useUpdateAdminGroupPolicyMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ groupKey, policy }: { groupKey: string; policy: AccessPolicyUpdate }) => {
      return await updateAdminGroupPolicy(groupKey, policy)
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["admin", "admin-groups"] })
    },
  })
}
